module.exports = __webpack_public_path__ + "assets/img/browse.73942e5b.png";